<script lang="ts">
    // Botão de "acrescentar mais um" de uma lista: contorno tracejado, ocupando a linha inteira, no
    // lugar onde o próximo item vai aparecer. Estava repetido como .add em cada folha (orçamento,
    // PDV, agendamento); aqui vira peça única para as telas de desktop também usarem.
    import Fa from 'svelte-fa'
    import { faPlus } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    let className: string = ''
    export { className as class }
    export let label: string = 'Adicionar'
    export let disabled: boolean = false
    // contorno cheio em vez de tracejado, para quando o botão não abre uma nova linha da lista
    export let solid: boolean = false
</script>

<button type="button" class="zadd {className}" class:solid {disabled} on:click={() => dispatch('click')}>
    <Fa icon={faPlus} />
    {label}
</button>

<style>
    /* valores base = tema escuro; as variáveis vêm de css_z_field.css e já mudam no tema claro */
    .zadd {
        width: 100%;
        border: 1px dashed #ffffff33;
        background: none;
        color: inherit;
        font: inherit;
        font-size: 14px;
        border-radius: var(--z-field-radius);
        padding: 10px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        min-height: var(--z-field-height);
        cursor: pointer;
        transition:
            border-color 0.12s ease,
            background-color 0.12s ease;
    }
    .zadd:hover:not(:disabled) {
        border-color: var(--z-field-focus);
        background: var(--z-field-bg);
    }
    .zadd:disabled {
        opacity: 0.4;
        cursor: default;
    }
    .zadd.solid {
        border-style: solid;
        border-color: var(--z-field-border);
        background: var(--z-field-bg);
    }

    :global(.theme_light) .zadd {
        border-color: #d8dbe0;
    }
</style>
